import type { UsdvMigrationPlan } from "@solomon-apps/shared";
import { BigDecimal } from "@solomon-labs/bigdecimal";

export interface MigrationSettlement {
    owner: string;
    action: "unstake" | "claim" | "swap";
    before: UsdvMigrationPlan;
    plan: UsdvMigrationPlan;
}

const queuedAmount = (plan: UsdvMigrationPlan): BigDecimal =>
    (plan.claimableUsdv ?? new BigDecimal(0)).add(plan.coolingUsdv ?? new BigDecimal(0));

/** Recognize the consumed input and changed queue, never require an estimate to equal chain precision. */
export function hasObservedMigrationSettlement(settlement: MigrationSettlement, live: UsdvMigrationPlan): boolean {
    switch (settlement.action) {
        case "unstake":
            return (
                live.stakedUsdv.lte(settlement.plan.stakedUsdv) &&
                queuedAmount(live).gt(queuedAmount(settlement.before))
            );
        case "claim":
            return (
                queuedAmount(live).lt(queuedAmount(settlement.before)) &&
                live.legacyUsdv.gte(settlement.plan.legacyUsdv)
            );
        case "swap":
            return live.legacyUsdv.lte(settlement.plan.legacyUsdv);
    }
}
